const tagsStoreInitialState = {
  sponsoredTags: [],
  broadcasters: [],
  totalCountSponsoredTags: 0,
  offsetSponsoredTags: 0,
  totalCountBroadcasters: 0,
  offsetBroadcasters: 0,
  showTagsList: true,
  selectedTag: '',
  tagId: 0,
  switchValueIndex: 0,
  switchValueType: true,
  switchValueSaved: true,
  switchValueOriginal: true,
  predefinedTags: [],
  anchorPredefinedTags: null,
  isPredefinedTagVisible: false,
  chosenTags: [],
  searchPredefinedTagValue: '',
};

export default tagsStoreInitialState;
